
        // Handle URL parameters for theme demo
        const urlParams = new URLSearchParams(window.location.search);
        const demoTheme = urlParams.get('theme');
        const isDemo = urlParams.get('demo');

        // Wait for theme switcher to be available
        let themeSwitcherCheckInterval = setInterval(() => {
            if (typeof themeSwitcher !== 'undefined') {
                clearInterval(themeSwitcherCheckInterval);
                
                // Apply theme from URL parameter if provided
                if (demoTheme) {
                    themeSwitcher.switchTheme(demoTheme);
                }

                // Handle demo mode
                if (isDemo) {
                    // Hide floating theme switcher in demo iframe
                    const floatingSwitcher = document.getElementById('floating-theme-switcher');
                    if (floatingSwitcher) {
                        floatingSwitcher.style.display = 'none';
                    }
                }
            }
        }, 100);

        // Listen for theme change messages from parent window (demo page)
        window.addEventListener('message', (event) => {
            if (event.data?.type === 'THEME_CHANGE' && typeof themeSwitcher !== 'undefined') {
                themeSwitcher.switchTheme(event.data.theme);

                // Apply custom colors if provided
                if (event.data.customColors) {
                    Object.entries(event.data.customColors).forEach(([colorVar, colorValue]) => {
                        document.documentElement.style.setProperty(colorVar, colorValue);
                    });
                }
            }
        });

        // Notify parent window that iframe is ready
        if (window.parent !== window) {
            window.parent.postMessage({ type: 'IFRAME_READY' }, '*');
        }
    